import authApi from "../api/authApi";
import { getUserProfile } from "../api/user.api";

/** Swagger: GET /user/user/profile → UserProfile.mfa_enabled */
export async function getMfaStatus() {
	const data = await getUserProfile();
	const profile = data?.user || data || {};
	return {
		enabled: profile.mfa_enabled === true,
		mfa_enabled: profile.mfa_enabled === true
	};
}
export async function enableMfa() {
	const { data } = await authApi.post("/mfa/enable", {}, { params: { check_mfa: true } });
	return data;
}

export async function verifyMfa(code) {
	const payload = { code: String(code || "").trim() };
	const { data } = await authApi.post("/mfa/verify", payload, { params: { check_mfa: true } });
	return data;
}

export async function generateBackupCodes() {
	const { data } = await authApi.post("/mfa/backup-codes/generate", {}, { params: { check_mfa: true } });
	return data;
}

export async function disableMfa(password, code) {
	const payload = {
		password: String(password || ""),
		code: String(code || "").trim()
	};
	const { data } = await authApi.post("/mfa/disable", payload, { params: { check_mfa: true } });
	return data;
}
